export default class GoogleConfigurationDto
{
    public key: string|null = null;
    public debug = false;
    public consent = true;
    public personalization = false;
    public useBeacon = true;
}